import React, { Fragment } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import AnchorLink from 'react-anchor-link-smooth-scroll';

// styles
import './ycHeader.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

// constants
import { PATHS, Langs } from '../../constants';

// constants
import { ClickLink } from '../../tools/Utils';

// images
import logoImg from '../../assets/images/c-header/logo-ysocorp.svg';
import { getI18nPath } from '@/constants';

type Props = {
  location: {
    pathname: string,
  },
};

class YcHeaderView extends React.PureComponent<Props> {
  state = {
    isWhite: false,
    isScroll: false,
  };

  forceWhitePages = ['/games', '/privacy-policy'];

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.updateLocation({ location: {} });
  }

  handleScroll = event => {
    const scrollTop = window.pageYOffset;
    this.setState({
      isScroll: scrollTop > 50,
    });
  };

  componentDidUpdate(prevProps) {
    this.updateLocation(prevProps);
  }

  updateLocation(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(window.scrollX, 0);
    }
    let isWhite = false;
    if (this.forceWhitePages.indexOf(this.props.location.pathname) !== -1 || document.body.classList.contains('white-theme')) {
      isWhite = true;
    }

    this.setState({
      isWhite: isWhite,
    });
  }

  getClasses() {
    let classes = 'navbar-light';
    if (this.state.isScroll || this.state.isXsOpen) {
      classes = 'navbar-light';
    }
    return classes;
  }

  _imageColor(img1, img2) {
    if (!this.state.isXsOpen && !this.state.isScroll) {
      return img1;
    }
    return img2;
  }

  getLogo() {
    return logoImg;
  }

  clickLink = action => {
    ClickLink(action);
  };

  getActuelLang() {
    const link = this.props.location.pathname;
    return link.split('/')[1];
  }

  changeLang(lang) {
    const link = this.props.location.pathname;
    const useLang = link.split('/')[1];
    return link.replace(useLang, lang);
  }

  renderLogo() {
    return (
      <NavLink to={getI18nPath(PATHS.home)}>
        <img alt="logo" className="logo" src={this.getLogo()} />
      </NavLink>
    );
  }

  renderLinks(className = '') {
    const { t } = this.props;

    return (
      <Fragment>
        <li className="nav-item" data-toggle="collapse" data-target="#navbarSupportedContent">
          <NavLink exact to={getI18nPath(PATHS.home)} className="nav-link" onClick={() => this.clickLink('#home')}>
            {t('menu.home')}
          </NavLink>
        </li>
        <li className="nav-item" data-toggle="collapse" data-target="#navbarSupportedContent">
          <NavLink to={getI18nPath(PATHS.aboutUs)} className="nav-link" onClick={this.clickLink}>
            {t('menu.about us')}
          </NavLink>
        </li>
        <li className="nav-item" data-toggle="collapse" data-target="#navbarSupportedContent">
          <NavLink to={getI18nPath(PATHS.projects)} className="nav-link" onClick={this.clickLink}>
            {t('menu.projects')}
          </NavLink>
        </li>
        <li className="nav-item" data-toggle="collapse" data-target="#navbarSupportedContent">
          <AnchorLink offset="0px" href="#contact-us" className="nav-link">
            {t('menu.contact-us')}
          </AnchorLink>
        </li>
        <li className="nav-item">
          <a offset="0px" href="https://www.ysocorp.com/" className="nav-link">
            {t('menu.game')}
          </a>
        </li>
      </Fragment>
    );
  }

  render() {
    Langs.map((lang, index) => (
      <Fragment>
        <a href={this.changeLang(lang)}>
          <span className={this.getActuelLang() === lang ? 'active' : 'nactive'}>{lang.toUpperCase()}</span>
        </a>
        {Langs[index + 1] ? ' | ' : ''}
      </Fragment>
    ));
    return (
      <nav className={'navbar navbar-collapse navbar-expand-lg navbar-light fixed-top p-4 ' + this.getClasses()}>
        {this.renderLogo()}
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto">{this.renderLinks()}</ul>
          {/* <div className="lang">{lang}</div> */}
        </div>
      </nav>
    );
  }
}

export const YcHeader = withTranslation()(withRouter(YcHeaderView));
